var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSupply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91082 2.33317C2.62615 2.33317 2.43252 2.52044 2.40493 2.72426C2.35771 3.07299 2.33329 3.42924 2.33329 3.7915C2.33329 8.14075 5.85905 11.6665 10.2083 11.6665C10.5706 11.6665 10.9268 11.6421 11.2755 11.5949C11.4794 11.5673 11.6666 11.3736 11.6666 11.089V9.59072C11.6666 9.33964 11.506 9.11672 11.2678 9.03732L9.43124 8.42515C9.2866 8.37694 9.13152 8.46207 9.09454 8.60998C8.82526 9.68712 7.48384 10.0587 6.69874 9.27358L4.72622 7.30105C3.94112 6.51596 4.31267 5.17454 5.38982 4.90525C5.53773 4.86827 5.62286 4.7132 5.57464 4.56855L4.96247 2.73204C4.88307 2.49384 4.66016 2.33317 4.40907 2.33317H2.91082ZM1.24881 2.56773C1.3651 1.70879 2.12304 1.1665 2.91082 1.1665H4.40907C5.16233 1.1665 5.83107 1.64851 6.06927 2.36311L6.68144 4.19962C6.94456 4.98899 6.47999 5.83528 5.67277 6.03709C5.4754 6.08643 5.40731 6.33223 5.55118 6.4761L7.5237 8.44862C7.66756 8.59248 7.91336 8.5244 7.96271 8.32702C8.16451 7.5198 9.01081 7.05523 9.80017 7.31835L11.6367 7.93053C12.3513 8.16873 12.8333 8.83747 12.8333 9.59072V11.089C12.8333 11.8768 12.291 12.6347 11.4321 12.751C11.0316 12.8052 10.6231 12.8332 10.2083 12.8332C5.21472 12.8332 1.16663 8.78508 1.16663 3.7915C1.16663 3.37674 1.19459 2.9682 1.24881 2.56773Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSupply);
export default __webpack_public_path__ + "static/media/phone_supply.ad3ece71abf83b518036efbed56e026a.svg";
export { ForwardRef as ReactComponent };